import { selectCurrentInstitutionPath } from '../Institutions/CurrentInstitutionPath/selectors';
import { ROUTE_INSTITUTION_ADMIN_SETTINGS } from '../routeActions';
import { ReduxState } from '../state';
import { Dispatch } from '../thunk';
import { ValidSectionId, ValidActionType } from './types';

export const navigateInstitutionAdminSettings = (
  sectionId: ValidSectionId,
  actionType: ValidActionType
) => (dispatch: Dispatch, getState: () => ReduxState): void => {
  const currentInstitutionPath = selectCurrentInstitutionPath(getState());

  if (currentInstitutionPath) {
    dispatch({
      type: ROUTE_INSTITUTION_ADMIN_SETTINGS,
      params: {
        sectionId,
      },
      query: {
        institution: currentInstitutionPath,
        action: actionType,
      },
    });
  }
};
